import React from "react";
import classes from "../styles/style.module.css";
import BookImage from "../../../assets/images/Roshana/bookImage.jpg";
import RoshanaButton from "../Button";
import RoshanaBanner from "../../../assets/images/Roshana/roshanaBanner.png";
import { useNavigate } from "react-router";

const TopBanner = () => {
  const navigate = useNavigate();
  return (
    <div className={classes.topBannerContainer}>
      <div className={classes.bannerTopSection}>
        <img src={RoshanaBanner} alt="roshanabanner" />
        <div className={classes.textContainer}>
          <p>یه حلقه کتابخوانی برای </p>
          <p>روشن کردن زندگی</p>
          <p>لازمه!</p>
          <RoshanaButton
            color={"secondary"}
            text={"ثبت نام"}
            handleClick={
              () => navigate("/forms")
              // window.open("https://uism.ir/", "_blank").focus()
            }
            styles={{ width: "60%", marginBlock: "10px" }}
          />
          <RoshanaButton
            color={"secondary"}
            text={"کانال اطلاع رسانی"}
            handleClick={() =>
              window
                .open(
                  "https://eitaa.com/joinchat/3971416896C2a7b4c4afc",
                  "_blank"
                )
                .focus()
            }
            styles={{ width: "60%", marginBlock: "10px" }}
          />
        </div>
        <div className={classes.bannerbottomSection}>
          <div className={classes.bookContainer}>
            <img
              style={{ borderRadius: "12px" }}
              src={
                "https://api.v2.rahebehesht.com/file/get/PagePoster_1784451085.jpg"
              }
              alt="bookImage"
            />
            <div className={classes.bookTextContainer}>
              <p>جمع‌خوانی کتاب</p>
              <p>بی چهرگان</p>
            </div>
          </div>
          <RoshanaButton
            color={"secondary"}
            text={"کتاب های گذشته"}
            handleClick={
              () => navigate("/archive?filter=روشنا ثبت نام")
            }
            styles={{ width: "60%", marginBlock: "10px" }}
          />
        </div>
      </div>
      {/* <RoshanaButton
        color={"primary"}
        text={"ورود"}
        handleClick={() => window.open("https://uism.ir/", "_blank").focus()}
        styles={{ width: "60%", marginBlock: "20px" }}
      />
      <RoshanaButton
        color={"primary"}
        text={"کانال اطلاع رسانی"}
        handleClick={() =>
          window
            .open("https://eitaa.com/joinchat/3971416896C2a7b4c4afc", "_blank")
            .focus()
        }
        styles={{ width: "60%", marginBlock: "20px" }}
      /> */}
    </div>
  );
};

export default TopBanner;
